import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getCmdChartDefaultsSelector, getDatapointsConfigSelector } from '../../../configurations/selectors'
import { ICmdFacChartDefaults, IDataPointsConfig } from '../../../configurations/store/configurations.types'
import { setDefaultValue } from '../../../../utilities/data.util'
import { getRespiratoryOptionsSelector } from '../../../options/selectors/respiratoryOptions.selector'
import { IRespiratoryOptionsState } from '../../../options/store/options.types'
import { setRespiratory } from '../store/respiratory.actions'
import { getPcrIdSelector } from '../../../home/selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { IPcr } from '../../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { InitialAssessmentConstants } from '../../store/initialAssessment.constants'

export function* setRespiratoryDefaults() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (!pcrDoc.prNabc) {
      const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
      const cmdChartDefaults: ICmdFacChartDefaults = yield select(getCmdChartDefaultsSelector)
      const respiratoryOptions: IRespiratoryOptionsState = yield select(getRespiratoryOptionsSelector)
      const { CV_BREATH_SOUNDS_L, CV_BREATH_SOUNDS_R, CV_RESP_EFFORT, RESP_SOUNDS } = cmdChartDefaults

      const { breathSoundLeftOptions, breathSoundRightOptions, respEffortOptions } = respiratoryOptions

      const { DP_SHOWDEFAULTS, DP_BREATH_PICKLIST, DP_BREATH_COMMENTS } = datapointsConfig
      try {
        if (DP_SHOWDEFAULTS) {
          const cvBreathSoundsL = setDefaultValue(breathSoundLeftOptions, CV_BREATH_SOUNDS_L, DP_BREATH_PICKLIST)
          const cvBreathSoundsR = setDefaultValue(breathSoundRightOptions, CV_BREATH_SOUNDS_R, DP_BREATH_PICKLIST)
          const cvRespEffort = setDefaultValue(respEffortOptions, CV_RESP_EFFORT)
          const cvBreathComments = DP_BREATH_COMMENTS ? RESP_SOUNDS : ''

          const respItems = { cvBreathSoundsL, cvBreathSoundsR, cvRespEffort, cvBreathComments }
          yield put(setRespiratory(respItems))
        }
      } catch (e) {
        yield put(throwPcrException(`setRespiratoryDefaults() error: ${e}`))
      }
    }
  }
}

export function* setRespiratoryDefaultsSaga() {
  yield takeLatest([InitialAssessmentConstants.SET_PR_NABC_DEFAULTS], performWithMutexHOG, setRespiratoryDefaults)
}
